var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"corner-ribbon top-right sticky",class:{
      dark: !_vm.$store.state.isDarkTheme,
      light: _vm.$store.state.isDarkTheme,
    },on:{"click":function($event){return _vm.switchTheme()}}},[_vm._v("\n    "+_vm._s(_vm.switchThemeButtonText)+"\n  ")]),_c('nav-bar'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }